import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_FEE,
    DELETE_FEE,
    FEE_FORM_TOOGLE_LOADING,
    SET_FEE_LIST,
    SHOW_NOTIFICATION,
    UPDATE_FEE,
} from "../constants";
import { formatFees } from "./settingsActionsUtils";

/* FEE LIST */
export const fetchFees = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.fees.list)
            .then((response) => {
                const fees = formatFees(response.data);
                dispatch({
                    type: SET_FEE_LIST,
                    payload: keyBy(fees, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// FEES
export const createFee = (newFee) => {
    return async (dispatch) => {
        dispatch({ type: FEE_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.fees.create, newFee)
            .then((response) => {
                const fee = formatFees(response.data);
                dispatch({ type: ADD_NEW_FEE, payload: fee });
                dispatch({ type: FEE_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Tarifa creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: FEE_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateFee = (updatedFee) => {
    return async (dispatch) => {
        dispatch({ type: FEE_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.fees.edit}${updatedFee && updatedFee._id}`, updatedFee)
            .then((response) => {
                const fee = formatFees(response.data);
                dispatch({ type: UPDATE_FEE, payload: fee });
                dispatch({ type: FEE_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Tarifa actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: FEE_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteFees = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: FEE_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.fees.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_FEE, payload: Ids });
                dispatch({ type: FEE_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Tarifa eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: FEE_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
